var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getVersionTagId } from '@data/hooks/modelTable';
import { cellsApi } from '@data/rest/api';
import { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { parseInterval } from '@util/helpers';
import { getMutationOptionsFactory } from '@util/query';
import { cellRepresentationToListItem, listItemToCellRepersentation, newListItemToCreateCellRequest, } from './cell';
var PAGE_SIZE = 1000;
export var cellKeys = Object.freeze({
    all: ['cells'],
    listItemsTables: function () {
        return __spreadArray(__spreadArray([], __read(cellKeys.all), false), ['listItemsTables'], false);
    },
    listItemsTable: function (filter) {
        return __spreadArray(__spreadArray([], __read(cellKeys.listItemsTables()), false), [filter], false);
    },
});
var mutationOptionsFactory = getMutationOptionsFactory();
function createListItemsFilterContext(_a) {
    var _b, _c, _d, _e;
    var userSettings = _a.userSettings, internalTagsMap = _a.internalTagsMap, selectedSheetRow = _a.selectedSheetRow, activeVersions = _a.activeVersions, activeYears = _a.activeYears;
    var clusterTagIds = (_c = (_b = selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.allTags) === null || _b === void 0 ? void 0 : _b.map(function (t) { return t.id; })) !== null && _c !== void 0 ? _c : [];
    var intervalStart = (_d = userSettings.model_table_interval_start) !== null && _d !== void 0 ? _d : '1/0000';
    var intervalEnd = (_e = userSettings.model_table_interval_end) !== null && _e !== void 0 ? _e : '12/9999';
    var _f = parseInterval(intervalStart, intervalEnd, activeYears), startMonth = _f.startMonth, startYear = _f.startYear, endMonth = _f.endMonth, endYear = _f.endYear;
    var versions = userSettings.model_table_filtered_versions.length === 0
        ? []
        : activeVersions === null || activeVersions === void 0 ? void 0 : activeVersions.filter(function (v) { return userSettings.model_table_filtered_versions.includes(v.id); });
    return {
        activeYears: activeYears,
        activeVersions: versions,
        intervalData: { monthStart: startMonth, yearStart: startYear, monthEnd: endMonth, yearEnd: endYear },
        globalTagIds: clusterTagIds,
        internalTags: internalTagsMap,
    };
}
function hasNecesaryDeps(dependencies) {
    return !!(dependencies.activeYears &&
        dependencies.internalTagsMap &&
        dependencies.tagByIdMap &&
        dependencies.userSettings &&
        dependencies.selectedSheetRow &&
        dependencies.activeVersions);
}
function createTagIdsFilter(_a) {
    var e_1, _b;
    var activeYears = _a.activeYears, _c = _a.intervalData, monthStart = _c.monthStart, yearStart = _c.yearStart, monthEnd = _c.monthEnd, yearEnd = _c.yearEnd, _d = _a.internalTags, years = _d.years, months = _d.months, activeVersions = _a.activeVersions, globalTagIds = _a.globalTagIds;
    var orTagIds = [];
    var _loop_1 = function (year) {
        if (year < yearStart || year > yearEnd) {
            return "continue";
        }
        var ms = yearStart === year ? monthStart : 1;
        var me = yearEnd === year ? monthEnd : 12;
        var yearTag = years.find(function (y) { return y.name === "Y".concat(year); });
        if (!yearTag) {
            return "continue";
        }
        var _loop_2 = function (month) {
            var e_2, _e;
            var monthTag = months.find(function (m) { return m.name === "M".concat(month); });
            if (!monthTag) {
                return "continue";
            }
            var andTagIds = (globalTagIds === null || globalTagIds === void 0 ? void 0 : globalTagIds.length)
                ? __spreadArray([yearTag.id, monthTag.id], __read(globalTagIds), false) : [yearTag.id, monthTag.id];
            if (!(activeVersions === null || activeVersions === void 0 ? void 0 : activeVersions.length)) {
                orTagIds.push(andTagIds);
                return "continue";
            }
            try {
                for (var activeVersions_1 = (e_2 = void 0, __values(activeVersions)), activeVersions_1_1 = activeVersions_1.next(); !activeVersions_1_1.done; activeVersions_1_1 = activeVersions_1.next()) {
                    var id = activeVersions_1_1.value.id;
                    var versionTagId = getVersionTagId(id, activeVersions);
                    orTagIds.push(__spreadArray(__spreadArray([], __read(andTagIds), false), [versionTagId], false));
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (activeVersions_1_1 && !activeVersions_1_1.done && (_e = activeVersions_1.return)) _e.call(activeVersions_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
        for (var month = ms; month <= me; month++) {
            _loop_2(month);
        }
    };
    try {
        for (var activeYears_1 = __values(activeYears), activeYears_1_1 = activeYears_1.next(); !activeYears_1_1.done; activeYears_1_1 = activeYears_1.next()) {
            var year = activeYears_1_1.value;
            _loop_1(year);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (activeYears_1_1 && !activeYears_1_1.done && (_b = activeYears_1.return)) _b.call(activeYears_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return orTagIds;
}
function getCellsPage(_a) {
    var queryKey = _a.queryKey;
    return __awaiter(this, void 0, Promise, function () {
        var _b, _c, tagIdsFilters, queryDependencies, page, cellReps;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = __read(queryKey, 3), _c = _b[2], tagIdsFilters = _c.tagIdsFilters, queryDependencies = _c.queryDependencies, page = _c.page;
                    if (!tagIdsFilters || !(queryDependencies === null || queryDependencies === void 0 ? void 0 : queryDependencies.tagByIdMap)) {
                        return [2 /*return*/, Promise.reject(new Error('Infinite cell query in useListItemsPagination tried to execute without necesary dependencies.'))];
                    }
                    if (!queryDependencies.selectedSheetRow) {
                        return [2 /*return*/, []];
                    }
                    if (queryDependencies.selectedSheetRow.allTags.length === 0) {
                        return [2 /*return*/, []];
                    }
                    return [4 /*yield*/, cellsApi.search({
                            tagIdsFilters: tagIdsFilters,
                            pageInfo: { index: page - 1, size: PAGE_SIZE },
                        })];
                case 1:
                    cellReps = _d.sent();
                    return [2 /*return*/, cellReps];
            }
        });
    });
}
export function createListItemsTagIdsFilter(dependencies) {
    if (!hasNecesaryDeps(dependencies)) {
        return;
    }
    var tagsContext = createListItemsFilterContext(dependencies);
    return createTagIdsFilter(tagsContext);
}
export function useListItemsPagination(page, dependencies) {
    var tagIdsFilters = createListItemsTagIdsFilter(dependencies);
    var key = cellKeys.listItemsTable({
        tagIdsFilters: tagIdsFilters,
        queryDependencies: __assign({}, dependencies),
        page: page,
    });
    var select = useCallback(function (data) {
        var tagByIdMap = dependencies.tagByIdMap;
        if (tagByIdMap) {
            return data.map(function (c) { return cellRepresentationToListItem(c, tagByIdMap); });
        }
    }, [dependencies.tagByIdMap]);
    var lineItemPages = useQuery(key, getCellsPage, {
        enabled: hasNecesaryDeps(dependencies),
        keepPreviousData: true,
        select: select,
    });
    return lineItemPages;
}
function deleteCell(cellId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, cellsApi.remove(cellId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function useDeleteListItem(page, dependencies) {
    var queryClient = useQueryClient();
    var tagIdsFilters = createListItemsTagIdsFilter(dependencies);
    var key = cellKeys.listItemsTable({ tagIdsFilters: tagIdsFilters, page: page });
    var options = mutationOptionsFactory.create('delete', key, queryClient);
    var deleteListItemMutation = useMutation(deleteCell, options);
    return deleteListItemMutation;
}
function updateListItem(listItem) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var cell;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Hmmmm, smelly 💩
                    (_a = listItem === null || listItem === void 0 ? void 0 : listItem.date) === null || _a === void 0 ? void 0 : _a.setHours(12);
                    cell = listItemToCellRepersentation(listItem);
                    return [4 /*yield*/, cellsApi.update(listItem.id, cell)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function useUpdateListItem(page, dependencies) {
    var queryClient = useQueryClient();
    var tagIdsFilters = createListItemsTagIdsFilter(dependencies);
    var key = cellKeys.listItemsTable({ tagIdsFilters: tagIdsFilters, page: page });
    var options = mutationOptionsFactory.createWithMapper('update', key, queryClient, listItemToCellRepersentation);
    var updateListItemMutation = useMutation(updateListItem, options);
    return updateListItemMutation;
}
function createListItem(newCell) {
    return __awaiter(this, void 0, void 0, function () {
        var celReq;
        return __generator(this, function (_a) {
            celReq = newListItemToCreateCellRequest(newCell);
            // Hmmmm, smelly 💩
            celReq.date.setHours(12);
            return [2 /*return*/, cellsApi.create(celReq)];
        });
    });
}
export function useCreateListItem(page, dependencies) {
    var queryClient = useQueryClient();
    var tagIdsFilters = createListItemsTagIdsFilter(dependencies);
    var key = cellKeys.listItemsTable({ tagIdsFilters: tagIdsFilters, page: page });
    var options = mutationOptionsFactory.create('create', key, queryClient);
    var createListItemMutation = useMutation(createListItem, options);
    return createListItemMutation;
}
